var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_1785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33325C11.6817 1.33325 14.6663 4.31792 14.6663 7.99992C14.6663 11.6819 11.6817 14.6666 7.99967 14.6666C4.31767 14.6666 1.33301 11.6819 1.33301 7.99992C1.33301 4.31792 4.31767 1.33325 7.99967 1.33325ZM7.99967 2.66659C6.58519 2.66659 5.22863 3.22849 4.22844 4.22868C3.22824 5.22888 2.66634 6.58543 2.66634 7.99992C2.66634 9.41441 3.22824 10.771 4.22844 11.7712C5.22863 12.7713 6.58519 13.3333 7.99967 13.3333C9.41416 13.3333 10.7707 12.7713 11.7709 11.7712C12.7711 10.771 13.333 9.41441 13.333 7.99992C13.333 6.58543 12.7711 5.22888 11.7709 4.22868C10.7707 3.22849 9.41416 2.66659 7.99967 2.66659ZM7.99967 3.99992C8.16296 3.99994 8.32057 4.05989 8.44259 4.1684C8.56461 4.2769 8.64257 4.42642 8.66167 4.58859L8.66634 4.66659V7.72392L10.471 9.52859C10.5906 9.64856 10.66 9.80954 10.6652 9.97884C10.6703 10.1481 10.6109 10.3131 10.4988 10.4401C10.3868 10.5671 10.2306 10.6468 10.062 10.6629C9.89341 10.6789 9.725 10.6302 9.59101 10.5266L9.52834 10.4713L7.52834 8.47125C7.42473 8.36755 7.35818 8.23259 7.33901 8.08725L7.33301 7.99992V4.66659C7.33301 4.48977 7.40325 4.32021 7.52827 4.19518C7.65329 4.07016 7.82286 3.99992 7.99967 3.99992Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_1785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/durationIcon.4bccf5449c9f2f0dde1a1bff98a69605.svg";
export { ForwardRef as ReactComponent };